const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class AdminSalesPopupStatisticsService {
  /**
   * Obtiene las estadísticas del popup de ventas
   */
  static async getStatistics(days = 30) {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/sales-popup/statistics/?days=${days}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching sales popup statistics:', error);
      throw error;
    }
  }
}

export default AdminSalesPopupStatisticsService;

